import { useQuery } from '@tanstack/react-query';

import getTalkingPointBrief from 'Api/productivity-host/getTalkingPointBrief';
import { useUserInfo } from 'Store/userInfo';

import getTalkingPointBriefResponse from './model/response/getTalkingPointBriefResponse';

const useGetTalkingPointBrief = () => {
  const { userBrand } = useUserInfo();
  return useQuery({
    queryKey: ['talking-points-brief', userBrand?.[0]],
    queryFn: async () => {
      const response = await getTalkingPointBrief();

      return getTalkingPointBriefResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetTalkingPointBrief;
